/* ==========================================================================
   Nestivori — JavaScript propio (vanilla, sin librerías)
   Una función init por componente. Todas comprueban si su elemento existe.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- apariciones al hacer scroll --- */
  function initReveals() {
    var els = document.querySelectorAll('.nv-reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('nv-visible');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el, i) {
      var d = el.getAttribute('data-nv-delay');
      el.style.transitionDelay = (d ? parseInt(d, 10) : Math.min(i % 6, 5) * 45) + 'ms';
      io.observe(el);
    });
  }

  /* --- añadir al carrito sin salir de la página --- */
  function initQuickAdd() {
    var btns = document.querySelectorAll('.nv-add[data-variant]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id = btn.getAttribute('data-variant');
        if (!id) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added';
            refreshCartCount();
            openCartDrawer();
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
            window.location.href = '/cart';
          });
      });
    });
  }

  /* Dawn expone el cajón del carrito como <cart-drawer>. Si no existe, no pasa nada. */
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) {}
    }
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* --- packs: añade todos los productos y aplica el descuento --- */
  function initPackAdd() {
    var btns = document.querySelectorAll('.nv-pack-add[data-variants]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-variants') || '')
          .split(',').map(function (s) { return Number(s.trim()); })
          .filter(function (n) { return n > 0; });
        if (!ids.length) return;

        var code = (btn.getAttribute('data-discount') || '').trim();
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            /* /discount/CODIGO aplica el descuento y luego lleva al carrito */
            window.location.href = code
              ? root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart'
              : root + 'cart';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
            window.location.href = root + 'cart';
          });
      });
    });
  }

  /* --- parallax suave sobre fotos ---
     Reglas que seguimos (guía de motion): solo sobre capas de imagen, NUNCA
     sobre texto; desplazamiento pequeño; un único observador y un único
     listener de scroll para todos; apagado en móvil y con movimiento reducido.
     will-change solo mientras el elemento está en pantalla. */
  function initParallax() {
    var els = document.querySelectorAll('[data-nv-parallax]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var visibles = [];
    var pendiente = false;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = visibles.indexOf(en.target);
        if (en.isIntersecting) {
          if (i === -1) visibles.push(en.target);
          en.target.style.willChange = 'transform';
        } else {
          if (i > -1) visibles.splice(i, 1);
          en.target.style.willChange = '';       /* libera GPU al salir */
        }
      });
      pintar();
    }, { rootMargin: '120px 0px' });

    els.forEach(function (el) { io.observe(el); });

    function pintar() {
      pendiente = false;
      var h = window.innerHeight;
      visibles.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var fuerza = parseFloat(el.getAttribute('data-nv-parallax')) || 8;
        /* -1 arriba del todo, +1 abajo del todo */
        var p = ((r.top + r.height / 2) - h / 2) / (h / 2);
        if (p > 1) p = 1;
        if (p < -1) p = -1;
        el.style.transform = 'translate3d(0,' + (p * fuerza).toFixed(2) + '%,0)';
      });
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    pintar();
  }

  /* --- carrusel de productos estrella ---
     Scroll nativo con scroll-snap: el dedo y el teclado ya funcionan solos.
     Las flechas solo se muestran si de verdad hay algo fuera de pantalla, y se
     desactivan al llegar a cada extremo para no engañar al que las mira. */
  function initCarruseles() {
    var pistas = document.querySelectorAll('[data-nv-carrusel]');
    if (!pistas.length) return;

    pistas.forEach(function (pista) {
      var seccion = pista.closest('section') || document;
      var caja = seccion.querySelector('[data-nv-flechas]');
      if (!caja) return;
      var botones = caja.querySelectorAll('[data-nv-dir]');

      function paso() {
        var card = pista.querySelector('.nv-estr-card');
        var ancho = card ? card.getBoundingClientRect().width + 16 : 316;
        return Math.max(ancho, Math.round(pista.clientWidth * 0.8));
      }

      function refrescar() {
        var hayResto = pista.scrollWidth - pista.clientWidth > 8;
        caja.hidden = !hayResto;
        if (!hayResto) return;
        var x = pista.scrollLeft;
        var max = pista.scrollWidth - pista.clientWidth;
        botones.forEach(function (b) {
          var dir = parseInt(b.getAttribute('data-nv-dir'), 10);
          b.disabled = dir < 0 ? x <= 2 : x >= max - 2;
        });
      }

      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-nv-dir'), 10);
          pista.scrollBy({ left: dir * paso(), behavior: reduce ? 'auto' : 'smooth' });
        });
      });

      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(refrescar);
      }, { passive: true });
      window.addEventListener('resize', refrescar, { passive: true });

      refrescar();
      /* las fotos son lazy: al cargarse cambia el ancho real */
      window.setTimeout(refrescar, 600);
    });
  }

  /* --- cinta de garantías: bucle de verdad ---
     El CSS movía la pista un -50%. Eso solo empalma si las dos copias miden
     EXACTAMENTE lo mismo, y no era el caso (la pista medía 3124 px y una copia
     1366), así que al reiniciar daba un salto visible.
     Aquí medimos la distancia real entre el primer elemento y su copia, y esa
     es la que se desplaza. Empalme perfecto, mida lo que mida el texto. */
  function initMarquee() {
    var pistas = document.querySelectorAll('.nv-marquee-track');
    if (!pistas.length) return;

    function medir(pista) {
      var items = pista.children;
      var mitad = Math.floor(items.length / 2);
      if (mitad < 1 || !items[mitad]) return;
      var salto = items[mitad].offsetLeft - items[0].offsetLeft;
      if (salto > 0) pista.style.setProperty('--nv-mq', salto + 'px');
    }

    function medirTodas() {
      pistas.forEach(medir);
    }

    medirTodas();
    window.addEventListener('resize', medirTodas, { passive: true });
    /* las fuentes cambian el ancho del texto al terminar de cargar */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(medirTodas);
    }
    window.setTimeout(medirTodas, 800);
  }

  /* --- hero: va rotando los productos estrella sobre el mismo vídeo ---
     Se para al pasar el ratón o al enfocar con el teclado, para que nadie
     pierda el botón mientras va a pulsarlo. Con movimiento reducido no rota
     sola: los puntos siguen funcionando a mano. */
  function initHeroSlides() {
    var cajas = document.querySelectorAll('[data-nv-hero-auto]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      var slides = caja.querySelectorAll('[data-nv-slide]');
      if (slides.length < 2) return;
      var contenedor = caja.parentElement;
      var puntos = contenedor ? contenedor.querySelectorAll('[data-nv-punto]') : [];
      var actual = 0;
      var reloj = null;
      var espera = (parseFloat(caja.getAttribute('data-nv-hero-auto')) || 6) * 1000;

      function mostrar(i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var on = n === actual;
          s.classList.toggle('is-on', on);
          if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        puntos.forEach(function (p, n) {
          p.setAttribute('aria-selected', n === actual ? 'true' : 'false');
        });
      }

      function arrancar() {
        if (reduce || reloj) return;
        reloj = window.setInterval(function () { mostrar(actual + 1); }, espera);
      }
      function parar() {
        if (reloj) { window.clearInterval(reloj); reloj = null; }
      }

      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          parar();
          mostrar(parseInt(p.getAttribute('data-nv-punto'), 10));
          arrancar();
        });
      });

      var zona = contenedor || caja;
      zona.addEventListener('mouseenter', parar);
      zona.addEventListener('mouseleave', arrancar);
      zona.addEventListener('focusin', parar);
      zona.addEventListener('focusout', arrancar);
      /* si la pestaña no se ve, no gastamos ciclos */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      mostrar(0);
      arrancar();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initQuickAdd();
    initPackAdd();
    initParallax();
    initCarruseles();
    initMarquee();
    initHeroSlides();
  });
})();
